export default __webpack_public_path__ + "static/media/guide26.1cf862b1.png";